import React, { useCallback, useRef, useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";
import ja from "date-fns/locale/ja";
registerLocale("ja", ja);

import axios from "../redux/sagas/axios";
import Contents from "../contents/index";
import ModalAlert from "../redux/components/modal/modal_alert";
import ModalLoader from "../modal/modal_loader";
import compressImage from "../../lib/image_compressor";

const Edit = ({ recipe, isApp }) => {
  const [title, setTitle] = useState(recipe.title || "");
  const [description, setDescription] = useState(recipe.description || "");
  const [publishDatetime, setPublishDatetime] = useState(
    recipe.publish_datetime
      ? moment(recipe.publish_datetime).toDate()
      : new Date()
  );
  const [isPublishDateDisplay, setIsPublishDateDisplay] = useState(
    recipe.is_publish_date_display || false
  );
  const [hideBreadcrumb, setHideBreadcrumb] = useState(
    recipe.hide_breadcrumb || false
  );
  const [isDeleted, setIsDeleted] = useState(recipe.is_deleted || false);
  const [isNextButtonDisplayed, setIsNextButtonDisplayed] = useState(true);
  const [photoUrl, setPhotoUrl] = useState(recipe.keyvisual || "");

  const successRef = useRef(null);
  const errorRef = useRef(null);
  const loaderRef = useRef(null);

  const onChangeMainImage = useCallback(
    async (photoFile) => {
      const compressedFile = await compressImage(photoFile)
      let formData = new FormData();
      formData.append("file", compressedFile);
      axios
        .patch(`/api/recipes/${recipe.id}/upload_image`, formData)
        .then((response) => {
          loaderRef.current.closeModal();
          if (response.status === 200) {
            setPhotoUrl(response.data.keyvisual_url_medium);
          } else {
            errorRef.current.openModal();
          }
        })
        .catch(() => {
          loaderRef.current.closeModal();
          errorRef.current.openModal();
        });
    },
    [loaderRef, errorRef]
  );

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      loaderRef.current.openModal();

      const body = JSON.stringify({
        title,
        description,
        publish_datetime: publishDatetime,
        is_publish_date_display: isPublishDateDisplay,
        hide_breadcrumb: hideBreadcrumb,
        is_deleted: isDeleted,
      });
      axios
        .patch(`/api/recipes/${recipe.id}`, body)
        .then((response) => {
          loaderRef.current.closeModal();
          if (response.status === 200) {
            successRef.current.openModal();
          } else {
            errorRef.current.openModal();
          }
        })
        .catch(() => {
          loaderRef.current.closeModal();
          errorRef.current.openModal();
        });
    },
    [
      loaderRef,
      successRef,
      errorRef,
      recipe,
      title,
      description,
      publishDatetime,
      isPublishDateDisplay,
      hideBreadcrumb,
      isDeleted,
    ]
  );

  const toRecipePage = useCallback(() => {
    window && (window.location.href = `/recipes/${recipe.id}`);
  }, []);

  return (
    <div>
      <main
        style={{ paddingBottom: isApp == false ? "165px" : "66px" }}
        className="bg-gray h-100 pt-3 min-vh-100"
      >
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            記事のタイトル
            <span className="message-required d-inline-block mb-2 ml-2">
              必須
            </span>
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            ディスクリプション
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            画像
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5 d-flex justify-content-around">
            <label htmlFor="photo_data">
              <a
                className={`card border-0 d-flex justify-content-center align-items-center hov--default p-3_5 d-block`}
              >
                {photoUrl ? (
                  <img
                    src={photoUrl}
                    alt=""
                    className="card-img-top card-img-top--list_eventreport mb-0 w-100"
                  />
                ) : (
                  <span className="d-block text-center text-black-20 text-fz-small">
                    写真をアップロード
                  </span>
                )}
                <input
                  type="file"
                  accept="image/png, image/jpeg"
                  onChange={(e) => {
                    onChangeMainImage(e.target.files[0]);
                  }}
                  id="photo_data"
                  style={{ display: "none" }}
                />
              </a>
            </label>
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            公開日
            <span className="message-required d-inline-block mb-2 ml-2">
              必須
            </span>
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <DatePicker
              selected={publishDatetime}
              onChange={(date) => setPublishDatetime(date)}
              showTimeInput
              withPortal
              dateFormat="yyyy/MM/dd  HH:mm"
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            公開日を表示/非表示
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <label>
              <input
                type="radio"
                name="is-publish-date-display"
                className=""
                checked={isPublishDateDisplay ? 1 : 0}
                onChange={() => setIsPublishDateDisplay(true)}
              />
              表示
            </label>
            <label>
              <input
                type="radio"
                name="is-publish-date-display"
                className="ml-3"
                checked={!isPublishDateDisplay ? 1 : 0}
                onChange={() => setIsPublishDateDisplay(false)}
              />
              非表示
            </label>
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            パンくずを表示/非表示
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <label>
              <input
                type="radio"
                name="hide-breadcrumb"
                className=""
                checked={!hideBreadcrumb ? 1 : 0}
                onChange={() => setHideBreadcrumb(false)}
              />
              表示
            </label>
            <label>
              <input
                type="radio"
                name="hide-breadcrumb"
                className="ml-3"
                checked={hideBreadcrumb ? 1 : 0}
                onChange={() => setHideBreadcrumb(true)}
              />
              非表示
            </label>
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            公開/非公開
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <label>
              <input
                type="radio"
                name="is-deleted"
                className=""
                checked={!isDeleted ? 1 : 0}
                onChange={() => setIsDeleted(false)}
              />
              表示
            </label>
            <label>
              <input
                type="radio"
                name="is-deleted"
                className="ml-3"
                checked={isDeleted ? 1 : 0}
                onChange={() => setIsDeleted(true)}
              />
              非表示
            </label>
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            本文
          </p>
        </div>
        <Contents
          foreignKeyId={recipe.id}
          isApp={isApp}
          model={"Recipe"}
          isCoursesDisplayed={true}
          displayNextButtonFunc={() => setIsNextButtonDisplayed(true)}
          hideNextButtonFunc={() => setIsNextButtonDisplayed(false)}
        />
      </main>
      {isNextButtonDisplayed && (
        <div
          className="fixed-bottom"
          style={{ paddingBottom: isApp == false ? "80px" : "" }}
        >
          <div className="container col-md-8 col-lg-6 d-flex justify-content-around">
            <div
              className="container d-flex justify-content-around"
              style={{ marginBottom: isApp ? "24px" : "" }}
            >
              <button
                type="button"
                className={`col-6 a-button a-button__top a-button--orange mr-2 w-100 ${
                  isApp == false ? "mb-2" : ""
                }`}
                onClick={(e) => onSubmit(e)}
              >
                作成/更新する
              </button>
            </div>
          </div>
        </div>
      )}
      <ModalAlert
        ref={successRef}
        title="レシピ作成完了"
        content="レシピ作成/更新に成功しました。"
        approveFunc={toRecipePage}
      />
      <ModalAlert
        ref={errorRef}
        title="レシピ作成失敗"
        content="レシピ作成に失敗しました。時間をおいてもう一度お試しください。"
      />
      <ModalLoader ref={loaderRef} />
    </div>
  );
};

export default Edit;
